import {CONTACT_US} from '../../../../Config/ApiUrl'
import {textColumn} from "../../../../Helpers/TableCommonColumn";

export default {
    data() {
        return {
            options: {
                name: this.$t('contact_us'),
                url: CONTACT_US,
                showHeader: true,
                tableShadow: false,
                columns: [
                    textColumn(this.$t('name'), 'name'),
                    textColumn(this.$t('mobile'), 'mobile'),
                    textColumn(this.$t('email'), 'email'),
                    textColumn(this.$t('subject'), 'subject'),
                    textColumn(this.$t('description'), 'description'),
                ],
                showFilter: true,
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
                actions: [],
            }
        }
    },
}